import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeleteCustomer = () => {
  const queryClient = useQueryClient();

  return apiClient.customer.deleteCustomer.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      toast.success('Customer deleted!');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Error deleting the customer!');
    },
  });
};
